<template>
  <div class="p-4 bg-white text-xs">
    <div class="flex justify-between">
      <div>
        <span class="text-gray-600">From:</span>
        <span class="text-gray-700 font-medium">{{ senderName }}</span>
      </div>
      <div>
        <span class="text-gray-600">Status:</span>
        <span class="text-gray-700 font-medium">{{ this.smsMessageTrackingLog.status }}</span>
      </div>
    </div>
    <p class="text-sm">
      {{ smsMessageTrackingLog.sms_message.content }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    smsMessageTrackingLog: {
      type: Object,
      required: true,
    },
  },
  computed: {
    senderName() {
      if (!this.smsMessageTrackingLog.sender) {
        return 'N/A';
      }

      if (this.smsMessageTrackingLog.sender_type === 'users') {
        return this.smsMessageTrackingLog.sender.fullName;
      }

      if (this.smsMessageTrackingLog.sender_type === 'sms_campaign') {
        return this.smsMessageTrackingLog.sender.name;
      }

      return 'Unknown sender type';
    },
  },
};
</script>
